import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

const PreorderForm = () => {
  const navigate = useNavigate()

  const defaultValues = {
    mid: '',
    cake_list: [],
    fullname: '',
    phone: '',
    email: '',
    evt_date: '',
    evt_time: '',
    delivery: 'yes',
    delivery_add: '',
    special_inst: '',
    terms: false,
    del: 'no',
    created_at: new Date(),
    updated_at: null,
  }
  const [formFields, setFormFields] = useState(defaultValues)

  const changeFieldText = (event) => {
    const { name, value } = event.target
    setFormFields({ ...formFields, [name]: value })
    localStorage.setItem('formFields', JSON.stringify({ ...formFields, [name]: value }))
  }

  const submitOrder = (event) => {
    event.preventDefault()
    localStorage.setItem('formFields', JSON.stringify(formFields))
    navigate('/book', { replace: true })
  }

  return (
    <section className="preorder-ticket">
      <form onSubmit={submitOrder} className="preorder-ticket__card">
        <div className="preorder-ticket__stamp" aria-hidden="true">
          Hold
          <span>the date</span>
        </div>

        <div className="preorder-ticket__head">
          <p>Bakery claim check</p>
          <h2>Book a bake</h2>
        </div>

        <div className="preorder-ticket__body">
          <label className="preorder-ticket__chip">
            <span>When do you need it?</span>
            <input name="evt_date" type="date" onChange={changeFieldText} required />
          </label>

          <label className="preorder-ticket__chip">
            <span>Best number to reach you</span>
            <input
              name="phone"
              type="tel"
              placeholder="(555) 000-0000"
              onChange={changeFieldText}
              required
            />
          </label>
        </div>

        <div className="preorder-ticket__foot">
          <p>No payment yet. Just tell us when.</p>
          <button type="submit">Punch my ticket</button>
        </div>
      </form>
    </section>
  )
}

export default PreorderForm
